import React from 'react';

export const Courses = () => {
  return <div>Coming Soon</div>;
};
